import React from 'react';
import HamHeader from '../Header/HamburgerHeader';
import cn from 'classnames';
import style from './sensors.module.scss';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const SensorCode = ({ sensorCode }) => (
  <div className="col-12 d-flex align-items-center justify-content-center px-0">
    <div className={cn(style.nameOfSensor, 'col-12')}>
      <div className="fw-500">{FLABEL().TABLE_SENSOR_SENSOR_CODE}</div>
      <input
        type="text"
        value={sensorCode || ''}
        className={cn(
          style.nameSensorInput,
          'col-12 pl-3 pr-5',
          style.disabled
        )}
        disabled
      />
    </div>
  </div>
);

const SensorGroupsList = ({ sensorGroupsList, group, setGroup }) => (
  <>
    <div className="fw-500 pb-2">{FLABEL().TABLE_SENSOR_SENSOR_GROUP}</div>
    <div className={style.subTitle}>{FLABEL().TABLE_SENSOR_SELECTION}</div>

    <div
      className={cn(
        style.sensorGrpsWrapper,
        style.sensorGrpsWrapper_named,
        'd-flex flex-column align-items-stretch col-12 px-0'
      )}
    >
      {sensorGroupsList.map(sensorGrp => (
        <div key={sensorGrp.id}>
          <div
            className={cn(
              style.sensorGrpName,
              'd-flex align-items-center justify-content-center p-3 w-100'
            )}
            style={{
              border: [group?.id].includes(sensorGrp.id)
                ? '2px solid var(--primary-selection-color)'
                : '2px solid transparent',
            }}
            onClick={() => setGroup(sensorGrp)}
          >
            {sensorGrp.name}
          </div>
        </div>
      ))}
    </div>
  </>
);

const SensorGroupEdit = ({
  setPopup,
  sensorGroupsList,
  selectedSensor,
  handleAssignSensorGroup,
  setGroup,
  group,
}) => {
  const handleBack = () => {
    setPopup(null);
    setGroup(null);
  };

  return (
    <div className={cn(style.RegisterSensor, 'h-100 p-3')}>
      <div className="mb-3">
        <HamHeader
          label={FLABEL().HEADER_ASSIGNSENSORGROUP}
          onClickback={handleBack}
        />
      </div>

      <div className={cn(style.registerContainer, 'col-12 px-0')}>
        <div
          className={cn(
            'd-flex h-100 flex-column align-items-center justify-content-center'
          )}
        >
          <div className={cn('col-8 h-100')}>
            <SensorCode sensorCode={selectedSensor?.externalId} />

            <div className={cn(style.sensorGrpsContainer, style.sensorGrps_2)}>
              <SensorGroupsList
                sensorGroupsList={sensorGroupsList}
                group={group}
                setGroup={setGroup}
              />

              <div className="d-flex gap-2 pt-3">
                <div className="col-6 pl-0 pr-2">
                  <button
                    className={cn(style.Secondarybtn, 'col-12 fw-500')}
                    onClick={() => setGroup(null)}
                  >
                    {FLABEL().TABLE_SENSOR_CLEAR}
                  </button>
                </div>
                <div className="col-6 pr-0 pl-2">
                  <button
                    className={cn(
                      style.primaryBtn,
                      !group && style.disabled,
                      'col-12 fw-500'
                    )}
                    onClick={() =>
                      handleAssignSensorGroup(selectedSensor?.id, group?.id)
                    }
                    disabled={!group}
                  >
                    {FLABEL().TABLE_SENSOR_SUBMIT}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SensorGroupEdit;
